/**
 * Allowed HTML tags for public-facing rich text content
 * Restrictive allowlist to prevent XSS attacks
 */
export const RICH_TEXT_ALLOWED_TAGS = [
  // Text formatting
  "em",
  "i",
  "strong",
  "b",
  "u",
  "s",
  "strike",
  // Structure
  "p",
  "br",
  "span",
  "div",
  // Lists
  "ul",
  "ol",
  "li",
  // Links
  "a",
  // Headings
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  // Code
  "code",
  "pre",
  // Quotes
  "blockquote",
];

/**
 * Allowed HTML attributes for public-facing rich text content
 * Restricted to safe attributes that don't enable XSS
 */
export const RICH_TEXT_ALLOWED_ATTR = [
  "style", // Inline styles (sanitized by DOMPurify)
  "class", // CSS classes
  "href", // Link URLs (javascript: protocol blocked by DOMPurify)
  "target", // Link target (_blank, etc.)
  "rel", // Link relationship (noopener, noreferrer for security)
  "title", // Tooltip text
];
